<template>
	<div class="task-log-list display-flex flex-column">
		<div v-if="!searchDisabled">
			<TaskLogListFilter @get-task-logs="getFilteredTaskLogs" @clearSelectedItem="clearSelectedItem" />
		</div>
		<div class="header-section flex-space-between--center mt-6">
			<div>Name</div>
			<div class="pr-14">Status</div>
		</div>
		<div class="flex-stretch-to-scroll display-flex flex-column">
			<Loader v-if="isLoadingLogs && page <= 1" />
			<div v-else>
				<div v-if="triggeredList.length === 0">No logs found</div>
				<div v-else>
					<perfect-scrollbar>
						<div v-for="triggeredFlow in triggeredList" :key="triggeredFlow.id" @click="setSelectedItem(triggeredFlow)">
							<TaskLogListItem :triggeredFlow="triggeredFlow" :isSelected="taskId === triggeredFlow.id" />
						</div>
						<div v-intersect="endIntersect" v-if="hasNextPage" class="load-more-empty-space width-100 display-flex flex-centerize">
							<div class="width-100">
								<AppLoader v-if="isLoadingLogs" />
							</div>
						</div>
					</perfect-scrollbar>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import router from '@/router';
import { mapGetters, mapActions } from 'vuex';
import { VIRTUAL_PROJECT_IDS } from '@/utils/projects.const';
import TaskLogListItem from '@/components/TaskLog/TaskLogListItem';
import TaskLogListFilter from '@/components/TaskLog/TaskLogListFilter';
import { selectedProjectId } from '@/store/modules/selectedProject/getters';
import { taskLog, loadingLogs, selectedTaskId } from '@/store/modules/analytics/getters';
import CreateAndManageService from '@/views/AppLayout/ManageAndCreate/create-and-manage-service';
import { ISSUES_MANAGEMENT_TASK_LOG_ROUTE_NAME, TASK_LOG_ROUTE_NAME } from '@/router/router.const';
const TASK_LOG_INFO_ROUTE = 'TaskLogInfo';

export default {
	name: 'TaskLogList',
	components: {
		TaskLogListFilter,
		TaskLogListItem,
	},
	props: {
		workflowId: { type: Number, required: false },
		errorMessage: { type: String, required: false },
		searchDisabled: { type: Boolean, default: false },
	},
	async created() {
		const params = this.workflowId && this.errorMessage ? { flow: this.workflowId, error_message: this.errorMessage } : {};
		await this.getTaskLogs(params);
		if (this.triggeredList.length > 0 && !this.taskId && this.isViewingTaskLog) {
			this.setSelectedItem(this.triggeredList[0]);
		}
	},
	computed: {
		...mapGetters([taskLog.fullPath, loadingLogs.fullPath, selectedTaskId.fullPath, selectedProjectId.fullPath]),
		triggeredList() {
			return this[taskLog.fullPath];
		},
		isLoadingLogs() {
			return this[loadingLogs.fullPath];
		},
		taskId() {
			return this[selectedTaskId.fullPath];
		},
		placementModePrefixName() {
			return CreateAndManageService.getPlacementRoutePrefix(this.$route);
		},
		hasNextPage() {
			return this.triggeredList.length >= this.numOfItemsInPage * (this.page - 1);
		},
		isIssueManagement() {
			return CreateAndManageService.isRouteOrChildOfRoute(this.$route, ISSUES_MANAGEMENT_TASK_LOG_ROUTE_NAME);
		},
		isViewingTaskLog() {
			return (
				CreateAndManageService.isRouteOrChildOfRoute(this.$route, ISSUES_MANAGEMENT_TASK_LOG_ROUTE_NAME) ||
				CreateAndManageService.isRouteOrChildOfRoute(this.$route, TASK_LOG_ROUTE_NAME)
			);
		},
	},
	methods: {
		...mapActions('analytics', ['getTaskLog']),
		endIntersect(entries, observer, isIntersecting) {
			if (isIntersecting) {
				this.getTaskLogs();
			}
		},
		setSelectedItem(triggeredFlow) {
			if (triggeredFlow.id !== this.taskId) {
				if (this.isIssueManagement) {
					const params = { flowRunId: triggeredFlow.id, pID: this[selectedProjectId.fullPath] };
					const name = this.placementModePrefixName + ISSUES_MANAGEMENT_TASK_LOG_ROUTE_NAME + TASK_LOG_INFO_ROUTE;
					router.push({ name, params });
				} else {
					router.push({ name: this.placementModePrefixName + TASK_LOG_INFO_ROUTE, params: { flowRunId: triggeredFlow.id } });
				}
			}
		},
		clearSelectedItem() {
			// this.setSelectedItem(null); // disabling it for now
		},
		async getTaskLogs(params = this.activeParams) {
			this.page++;
			if (!VIRTUAL_PROJECT_IDS.includes(this[selectedProjectId.fullPath])) {
				params.projectId = this[selectedProjectId.fullPath];
			}
			if (this.page > 1) {
				params.start = this.numOfItemsInPage * (this.page - 1);
			}
			this.activeParams = params;
			return this.getTaskLog(params);
		},

		getFilteredTaskLogs(params) {
			this.page = 0;
			this.getTaskLogs(params);
		},
	},
	data: () => ({
		page: 0,
		listHeaders: [],
		activeParams: {},
		numOfItemsInPage: 50,
	}),
};
</script>

<style scoped lang="scss">
.task-log-list {
	.header-section {
		margin: 20px 0 4px 0;
		padding: 20px 0 2px 0;
		font-size: 12px;
		border-bottom: var(--tertiary-border);
		color: var(--secondary-font-color);
	}
}
.load-more-empty-space {
	height: 100px;
}
</style>
